import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fedfb12"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "quill/dist/quill.core.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "quill/dist/quill.snow.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "quill/dist/quill.bubble.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "quill-mention/dist/quill.mention.min.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./index.vue?vue&type=style&index=4&id=0fedfb12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports